import React, { useState } from 'react'
import { Dialog, makeStyles } from '@material-ui/core'
import GlueButton from '../glueos-components/glue-button'
import InputField from './input-field'
import { apiQuery } from '../../services/backendApi'

const useStyles = makeStyles(theme => ({
  root: {
    width: ({ web }) => web ? '360px' : '640px',
    display: 'flex',
    flexFlow: 'column',
    alignItems: 'center',
    textAlign: 'center',
    gap: theme.spacing('xl'),
    padding: `0 ${theme.spacing('xl')}`,
    overflow: 'hidden'
  },

  title: {
    height: ({ web }) => web ? '36px' : '64px',
    display: 'flex',
    alignItems: 'center'
  },

  buttons: {
    display: 'flex',
    gap: theme.spacing('m')
  }
}), { name: 'MuiGlueForgotPasswordDialog' })

const ForgotPasswordDialog = (props) => {
  const classes = useStyles(props)
  const [ email, setEmail ] = useState(null)

  const resetPassword = () => {
    if (!email && email != null) {
      props.onChangeState(-2)
      return
    }

    props.onChangeState(1)
    apiQuery('/authenticated', {
      resetPassword: true,
      email: email ?? props.email,
      redirectUrl: window.location.origin, // TODO: Change this to web.glue.work?
      clientId: 'WwE5FyYTZXJUV0W3Hv4MBl0wvsgpOtNL'
    }).then(resp => {
      if (resp.result === 1) {
        props.onChangeState(2)
      } else {
        // Backend doesn't tell us what went wrong so there's just a generic error message to contact support
        props.onChangeState(-1)
      }
    })
  }

  const close = () => {
    props.onCloseDialog()
  }

  const errorMsg = props.state === -1 ? 'Please contact Glue support' : props.state === -2 ? 'Email cannot be empty' : null

  const inputChange = (value) => {
    setEmail(value)
    props.onChangeState(0)
  }

  return (
    <Dialog
      open={!!props.open}
      maxWidth={false}
    >
      <div className={classes.root}>
        {props.state === 2 ? (
          <>
            <div className={classes.title}>
              <h2>Check your email</h2>
            </div>
            <p>We have sent you instructions for resetting your password.<br />You may need to check your spam folder or unblock support@glue.work</p>
            <GlueButton color='primary' onPointerDown={close}>OK</GlueButton>
          </>
        ) : (
          <>
            <div className={classes.title}>
              <h2>Request password reset</h2>
            </div>
            <InputField width='100%' type='email' label='Email' defaultValue={props.email} value={email} onChange={inputChange} error={errorMsg} />
            <div className={classes.buttons}>
              <GlueButton onPointerDown={close} disabled={props.state === 1}>Cancel</GlueButton>
              <GlueButton color='primary' onPointerDown={resetPassword} disabled={props.state === 1}>Request</GlueButton>
            </div>
          </>
        )}
      </div>
    </Dialog>
  )
}

export default ForgotPasswordDialog
